export default {
    LIGHT_GREEN: '#5EB300',
    LOGIN_COLOR: '#48BB78',
    LOGOUT_COLOR: '#A0AEC0',
    LUNCH_COLOR: '#61B5FF',
    ADMINISTRATIVE_COLOR: '#003B4D',
    PRIVATE_COLOR: '#FF4D4D',
    HOLD_COLOR: '#E53E3E',
    OTHER_COLOR: '#ED64A6',
    TRAINING_COLOR: '#667EEA',
    TEAM_MEETING_COLOR: '#9F7AEA',
    BRIEF_COLOR: '#1CBBB4',
    QUEUE_LIGHT_GREEN: '#5EB300',
    QUEUE_LOGIN_COLOR: '#48BB78',
    QUEUE_LOGOUT_COLOR: '#A0AEC0',
    QUEUE_LUNCH_COLOR: '#61B5FF',
    QUEUE_ADMINISTRATIVE_COLOR: '#003B4D',
    QUEUE_PRIVATE_COLOR: '#FF4D4D',
    QUEUE_HOLD_COLOR: '#E53E3E',
    QUEUE_OTHER_COLOR: '#ED64A6',
    QUEUE_TRAINING_COLOR: '#667EEA',
    QUEUE_TEAM_MEETING_COLOR: '#9F7AEA',
    QUEUE_BRIEF_COLOR: '#1CBBB4'
}

export const colorsForPieChartCallsPerAccColorsLayout = {
    'Incoming': '#49ca6d',
    'Outgoing': '#61b5ff'
}


export const redesignCallTypeIcons = {
    incoming: 'ArrowDownLeft',
    incomingColor: '#10C67A',
    outgoing: 'ArrowUpRight',
    outgoingColor: '#4E62FF',
    otherCalls: 'IconMessageCircleMore',
    otherColor: '#B8BDC4'
}
